import React from 'react';
import { Typography } from 'antd';

const { Paragraph } = Typography;

const CommentParagraph = ({ content }) => {
  // Split the content at every newline, keep all including empty strings
  const contentArray = content.split('\n');

  return (
    <Paragraph>
      {contentArray.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {/* Always add <br />, even if the line is empty (to handle multiple \n) */}
          <br />
        </React.Fragment>
      ))}
    </Paragraph>
  );
};

export default CommentParagraph;
